import {
	getController,
	type HpRequestOptional,
	type HpRequestPostPut,
	apiService as Service,
} from '@/services/service'

const url = 'review_documents'

export const reviewDocumentService = {
	...getController<
		Api.ReviewDocument,
		Api.ReviewDocumentsPostInput,
		Api.ReviewDocumentsUpdateInput
	>(url),
	/*
	 * `documents.journals` haengt die Buchungszuordnung an jede Anlage: der
	 * Anlagen-Dialog zeigt sie am Ordner und in der Ansicht, ohne je Container
	 * einzeln nachzuladen. Das Konto kommt mit, weil der Chip die Kontonummer
	 * und den Kontonamen nennt.
	 *
	 * `documents.document_files` traegt den Belegbetrachter: der Beleg einer
	 * Buchung ist eine einzelne Datei, die uebrigen Blaetter derselben Anlage
	 * liegen im Container. Sie hier mitzunehmen erspart einen Aufruf je Beleg.
	 */
	show: (id: number, data?: HpRequestOptional) =>
		Service.get({
			url: `${url}/${id}?rel=["building", "team", "accounting_year", "documents", "documents.document_files", "documents.journals", "documents.journals.account.account_name"]`,
			...data,
		}),
	reviewAccount: (
		reviewDocumentId: number,
		accountId: number,
		data: HpRequestPostPut<unknown>
	) =>
		Service.post({
			url: `${url}/${reviewDocumentId}/accounts/${accountId}/review`,
			...data,
		}),
	/* Buchungssuche ueber alle Konten der Belegpruefung (Finder). */
	journals: (reviewDocumentId: number, data?: HpRequestOptional) =>
		Service.get<Api.Collection<Api.Journal>>({
			url: `${url}/${reviewDocumentId}/journals`,
			...data,
		}),
	commentSetting: (
		reviewDocumentId: number,
		data: HpRequestPostPut<Api.CommentSetting>
	) =>
		Service.post({
			url: `${url}/${reviewDocumentId}/comment-settings`,
			...data,
		}),
}
